var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
export default function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-helpers/esm/querySelectorAll.js
// module id = 362
// module chunks = 0